import dom from "../../../../dist/jsx-render/dom";
import { IAppComponent } from "../../../Frame/IAppComponent";
import { app } from "../../../Frame/App";
import { IGebaeudeItem } from "./IGebaeudeItem";
import { IFreigabe } from "./IFreigabe";
import { GebaeudePin } from "./Components/GebauedePin";
import { OverlapCalculator } from "./OverlapCalculator";
import { IAusserbetriebnahmeItem } from "./IAusserbetriebnahmeItem";
import { BuildingplanPins } from "./BuildingplanPins";

declare let gebaeude: IGebaeudeItem[];
declare let ausserbetriebnahmen: IAusserbetriebnahmeItem[];

const TIMER_IN_SECONDS = 15;

export class BuildingplanPage implements IAppComponent {

    private buttonGebaeude: HTMLElement;
    private contentImage: HTMLImageElement;
    private contentFrame: HTMLElement;
    private currentGebaeude: number = 0;
    private items: IFreigabe[];
    private calculator: OverlapCalculator;
    private timerId: number;
    private divMessstellen: HTMLElement;

    private localGebaeude: IGebaeudeItem[];
    private ressFolder: string;
    private filter: string;
    private currentMeasure?: number;

    public dynamicPins: IFreigabe[];

    //**initialise data for dynamic symbols*/
    initDynamicSymbols(selectedValues: number[], ressFolder: string) {
        this.ressFolder = ressFolder;
        this.dynamicPins = [];
        if (app.customerService && app.customerService.getClientData) {
            let measurePins = app.customerService.getClientData() as BuildingplanPins;
            this.dynamicPins = measurePins.getPins();
            this.currentMeasure = measurePins.getMeasureId();
        }
        if (selectedValues && selectedValues.length !== 0) {
            app.showWaitPanel();

            this.filter = JSON.stringify(selectedValues);
            var formData = new FormData();
            formData.append("values", this.filter);
            $.ajax({
                url: app.resolveUrl("~/api/kuraraygebaeudeplan/getGebaeudeListForSelectedBuildingplans"),
                type: "POST",
                dataType: 'json',
                processData: false,
                contentType: false,
                data: formData,
                success: (buildingplans: IGebaeudeItem[]) => {
                    if (buildingplans && buildingplans.length !== 0) {
                        this.localGebaeude = buildingplans;
                        this.createElement();

                        this.contentImage.style.cursor = "crosshair";
                        this.contentImage.onclick = (event: MouseEvent) => {
                            let positions = this.calculator.calcPercentage(event.offsetX, event.offsetY);
                            let newPin: IFreigabe = {
                                id: this.localGebaeude[this.currentGebaeude].id,
                                x: positions.X,
                                y: positions.Y
                            }

                            newPin.pin = new GebaeudePin({ item: newPin, calculator: this.calculator });
                            this.createEmptyPin(newPin, this.calculator);
                            this.dynamicPins.push({
                                id: newPin.id,
                                x: newPin.x,
                                y: newPin.y
                            });
                        }
                    }
                    else {
                        app.hideWaitPanel();
                    }
                },
                error: (err) => {
                    app.addError(err.responseText);
                },
            });
        }
    }

    //**Create empty pins (pins with only coordonates)*/
    private createEmptyPins = (pins: IFreigabe[], calculator: OverlapCalculator) => {
        if (pins && pins.length !== 0) {
            let currentBuildingplaPins = pins.filter(p => { return (p.id === this.localGebaeude[this.currentGebaeude].id || p.id === this.localGebaeude[this.currentGebaeude].equivalentOf) });
            if (currentBuildingplaPins && currentBuildingplaPins.length !== 0) {
                currentBuildingplaPins.forEach(pin => {
                    let item = JSON.parse(JSON.stringify(pin));
                    item.pin = new GebaeudePin({ item: item, calculator: this.calculator });
                    this.createEmptyPin(item, calculator);
                });
            }
        }
    }

    //**Create a single empty pin (pin with only coordonates)*/
    private createEmptyPin = (dynamicItem: IFreigabe, calculator: OverlapCalculator) => {
        let dynamicSymbol = dynamicItem.pin.renderEmptyElement(() => {

            let index = -1;
            for (var i = 0; i < this.dynamicPins.length; i++) {
                if (this.dynamicPins[i].id.toString() == dynamicSymbol.getAttribute("pin-image")
                    && this.dynamicPins[i].x.toString() == dynamicSymbol.getAttribute("pin-x")
                    && this.dynamicPins[i].y.toString() == dynamicSymbol.getAttribute("pin-y")) {
                    index = i;
                    break;
                }
            }
            
            if (index != -1) {
                this.dynamicPins.splice(index, 1);
            }

            app.destroyDomElements(dynamicSymbol);
        })

        this.contentImage.parentElement.appendChild(dynamicSymbol);
    }

    initialize() {
        this.localGebaeude = gebaeude;
        this.createElement();
    }

    createElement () {
        this.buttonGebaeude = document.getElementById("dropdownGebaeudeButton");
        this.contentImage = document.getElementById("contentImage") as HTMLImageElement;
        this.removeDynamicPins();
        this.ressFolder = this.contentImage.getAttribute("ressFolder");
        this.contentFrame = document.getElementById("contentFrame");
        this.divMessstellen = document.getElementById("divMessstellen");

        // fill gebauede dropdown
        this.fillMenu(this.filter != undefined);

        if (this.filter) {
            $('#dropdownGebaeudeFrame').on('show.bs.dropdown', () => {
                var formData = new FormData();
                formData.append("values", this.filter);
                $.ajax({
                    url: app.resolveUrl("~/api/kuraraygebaeudeplan/getGebaeudeListForSelectedBuildingplans"),
                    type: "POST",
                    dataType: 'json',
                    processData: false,
                    contentType: false,
                    data: formData,
                    success: (items: IGebaeudeItem[]) => {
                        this.localGebaeude = items;
                        this.fillMenu(this.filter != undefined);
                    },
                    error: (result) => {
                        app.addError(result.statusText + ": " + result.responseText);
                    },
                });
            });
        }
        else {
            $('#dropdownGebaeudeFrame').on('show.bs.dropdown', () => {
                $.get(app.resolveUrl("~/api/kuraraygebaeudeplan/getGebaeudeList"), (items: IGebaeudeItem[]) => {
                    this.localGebaeude = items;
                    this.fillMenu();
                }).fail((result) => {
                    app.addError(result.statusText + ": " + result.responseText);
                });
            });
        }

        // button left click
        document.getElementById("buttonLeft").addEventListener("click", this.showPrevImage);

        // button right click
        document.getElementById("buttonRight").addEventListener("click", this.showNextImage);

        // key events
        document.addEventListener("keydown", (ev: KeyboardEvent) => {
            if (ev.keyCode == 38) {
                // up arrow
                this.showPrevImage();
            }
            else if (ev.keyCode == 40) {
                // down arrow
                this.showNextImage();
            }
            else if (ev.keyCode == 37) {
                // left arrow
                this.showPrevImage();
            }
            else if (ev.keyCode == 39) {
                // right arrow
                this.showNextImage();
            }
        });

        // button maximize click
        document.getElementById("buttonMaximize").addEventListener("click", () => {
            this.contentFrame.requestFullscreen();
            document.getElementById("buttonMaximize").classList.add("d-none");
            document.getElementById("buttonMinimize").classList.remove("d-none");
        });

        // button minimize click
        document.getElementById("buttonMinimize").addEventListener("click", () => {
            document.exitFullscreen();
            document.getElementById("buttonMaximize").classList.remove("d-none");
            document.getElementById("buttonMinimize").classList.add("d-none");
        });

        // button play click
        document.getElementById("buttonPlay").addEventListener("click", () => {
            document.getElementById("buttonPlay").classList.add("d-none");
            document.getElementById("buttonStop").classList.remove("d-none");
            this.startTimer();
        });

        // button stop click
        document.getElementById("buttonStop").addEventListener("click", () => {
            document.getElementById("buttonStop").classList.add("d-none");
            document.getElementById("buttonPlay").classList.remove("d-none");
            this.stopTimer();
        });

        if (!this.filter) {
            // show first background image
            if (this.localGebaeude.length > 0) {
                if (this.localGebaeude[0].isPva) {
                    // show EG0 || E513
                    for (let item of this.localGebaeude) {
                        if (item.name.startsWith("EG0 || E513")) {
                            this.currentGebaeude = item.index;
                        }
                    }
                }
                else {
                    // show 468
                    for (let item of this.localGebaeude) {
                        if (item.name.startsWith("468")) {
                            this.currentGebaeude = item.index;
                        }
                    }
                }
            }
        }

        this.showImage(this.currentGebaeude);

        // handle resize event
        window.addEventListener("resize", () => {
            if (this.items) {
                this.createPins();
            }
        });
    }

    fillMenu(showAll: boolean = false) {
        const menu = document.getElementById("dropdownGebaeudeMenu");
        if (!menu) return;
        menu.innerHTML = "";
        for (let item of this.localGebaeude) {
            if (showAll || item.hasPins) {
                let menuItem = <a className="dropdown-item" href="#" data-index={item.index}>{this.getName(item.name, item.isPva)}</a>;
                menuItem.addEventListener("click", this.onMenuItemClicked);
                menu.appendChild(menuItem);
            }
        }
    }

    private getName = (name: string, isPva: boolean) => {
        if (isPva && this.isAlsoE512(name)) {
            return name.substring(0, 11) + " (E512)" + name.substring(11); 
        }
        return name;
    }

    private isAlsoE512 = (name: string): boolean => {
        return name &&
            (name.startsWith("EG0 || E513") ||
            name.startsWith("OG2 || E513") ||
            name.startsWith("OG5 || E513"))
    }

    startTimer() {
        this.timerId = window.setTimeout(this.onTimeout, 1000 * TIMER_IN_SECONDS);
    }

    stopTimer() {
        if (this.timerId) {
            window.clearTimeout(this.timerId);
            this.timerId = 0;
        }
    }

    onTimeout = () => {
        this.showNextImage();
        this.startTimer();
    }

    showPrevImage = () => {
        app.showWaitPanel();
        if (this.filter) {
            this.currentGebaeude--;
            if (this.currentGebaeude < 0) {
                this.currentGebaeude = this.localGebaeude.length - 1;
            }
            this.showImage(this.currentGebaeude);
        }
        else {
            $.get(app.resolveUrl("~/api/kuraraygebaeudeplan/getGebaeudeList"), (items: IGebaeudeItem[]) => {
                this.localGebaeude = items;
                $.get(app.resolveUrl("~/api/kuraraygebaeudeplan/getAusserbetriebnahmenList"), (items: IAusserbetriebnahmeItem[]) => {
                    ausserbetriebnahmen = items;
                    app.hideWaitPanel();
                    while (true) {
                        this.currentGebaeude--;
                        if (this.currentGebaeude < 0) {
                            this.currentGebaeude = this.localGebaeude.length - 1;
                        }
                        if (this.localGebaeude[this.currentGebaeude].hasPins) {
                            this.showImage(this.currentGebaeude);
                            break;
                        }
                    }
                }).fail((result) => {
                    app.hideWaitPanel();
                    app.addError(result.statusText + ": " + result.responseText);
                });
            }).fail((result) => {
                app.hideWaitPanel();
                app.addError(result.statusText + ": " + result.responseText);
            });
        }
    }

    showNextImage = () => {
        app.showWaitPanel();
        if (this.filter) {
            this.currentGebaeude++;
            if (this.currentGebaeude >= this.localGebaeude.length) {
                this.currentGebaeude = 0;
            }
            this.showImage(this.currentGebaeude);
        }
        else {
            $.get(app.resolveUrl("~/api/kuraraygebaeudeplan/getGebaeudeList"), (items: IGebaeudeItem[]) => {
                this.localGebaeude = items;
                $.get(app.resolveUrl("~/api/kuraraygebaeudeplan/getAusserbetriebnahmenList"), (items: IAusserbetriebnahmeItem[]) => {
                    ausserbetriebnahmen = items;
                    app.hideWaitPanel();
                    while (true) {
                        this.currentGebaeude++;
                        if (this.currentGebaeude >= this.localGebaeude.length) {
                            this.currentGebaeude = 0;
                        }
                        if (this.localGebaeude[this.currentGebaeude].hasPins) {
                            this.showImage(this.currentGebaeude);
                            break;
                        }
                    }
                }).fail((result) => {
                    app.hideWaitPanel();
                    app.addError(result.statusText + ": " + result.responseText);
                });
            }).fail((result) => {
                app.hideWaitPanel();
                app.addError(result.statusText + ": " + result.responseText);
            });
        }
    }

    onMenuItemClicked = (ev: Event) => {
        this.currentGebaeude = parseInt((ev.currentTarget as HTMLElement).getAttribute("data-index"));
        if (this.ressFolder) {
            let index: number = 0;
            for (let item of this.localGebaeude) {
                if (item.index == this.currentGebaeude) {
                    this.currentGebaeude = index;
                    break;
                }
                index++;
            }
        }

        this.showImage(this.currentGebaeude);
    }

    showImage(index: number) {
        app.showWaitPanel();

        if (this.ressFolder) {
            this.contentImage.src = app.resolveUrl(`~/images/Kuraray/Gebaeudeplan/Bilder/${this.ressFolder}/${this.localGebaeude[index].bild}`);
        }
        else {
            this.contentImage.src = app.resolveUrl(`~/images/Kuraray/Gebaeudeplan/Bilder/${this.localGebaeude[index].bild}`);
        }
        
        this.buttonGebaeude.innerText = this.localGebaeude[index].name;

        if (!this.filter) {
            this.showMessstellen();
        }

        $.get(app.resolveUrl(`~/api/kuraraygebaeudeplan/getfreigaben/${this.localGebaeude[index].id}`), (items: IFreigabe[]) => {
            this.removePins();
            if (this.currentMeasure) {
                this.items = items.filter(i => { return i.id !== this.currentMeasure });
            }
            else {
                this.items = items;
            }
            this.createPins();
            app.hideWaitPanel();
        }).fail((result) => {
            app.hideWaitPanel();
            app.addError(result.statusText + ": " + result.responseText);
        });
    }

    showMessstellen() {
        this.divMessstellen.innerHTML = "";
        if (ausserbetriebnahmen.length > 0) {
            this.divMessstellen.classList.remove("d-none");
            for (let item of ausserbetriebnahmen) {
                let div = <div className="mess-outer"><div className="mess-name">{item.name}</div><div className="mess-cat">{item.messstelle}</div></div>;
                this.divMessstellen.appendChild(div);
            }
        }
        else {
            this.divMessstellen.classList.add("d-none");
        }
    }

    createPins() {
        this.removePins();

        let imgWidth = this.contentImage.width;
        let imgHeight = this.contentImage.height;

        this.calculator = new OverlapCalculator(this.items, imgWidth, imgHeight, this.contentImage.naturalWidth, this.contentImage.naturalHeight);

        this.createImagePins(this.calculator);

        if (this.filter !== "") {
            this.createEmptyPins(this.dynamicPins, this.calculator);
        }
    }

    private createImagePins = (calculator: OverlapCalculator) => {
        for (let item of this.items) {
            item.pin = new GebaeudePin({ item: item, calculator: calculator });
            this.contentImage.parentElement.appendChild(item.pin.render());
        }
    }

    removePins() {
        if (this.items) {
            for (let item of this.items) {
                if (item.pin && item.pin.element?.parentElement) {
                    item.pin.element.parentElement.removeChild(item.pin.element);
                    item.pin = null;
                }
            }
        }

        this.removeDynamicPins();
    }

    public removeDynamicPins = () => {
        if (this.contentImage?.parentElement) {
            let dynamicPinsToDelete = this.contentImage.parentElement.querySelectorAll(".dynamic-symbol");
            if (dynamicPinsToDelete && dynamicPinsToDelete.length !== 0) {
                dynamicPinsToDelete.forEach(element => { app.destroyDomElements(element as HTMLElement); })
            }
        }
    }
}